module.exports = __webpack_public_path__ + "static/media/reward-bg@2x.c6284296.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/reward-bg@2x.png
// module id = 1121
// module chunks = 0